<template>
  <div class="pageslot-container">
    <!-- Aside열려있을때, 1200px이하 Dim-->
    <div class="tablet-aisde-dim" v-if="getIsOpenMenu" @click="onClickDim"></div>
    <!-- 로그아웃 Confirm -->
    <ConfirmYesNoV2 v-if="isLogoutConfirm" @click-no="isLogoutConfirm = false" @click-yes="onClickYesLogout">
      <template #confirmmodal-nontitle>로그아웃 하시겠습니까?</template>
    </ConfirmYesNoV2>
    <!-- NewSpace -->
    <AlertModalV2 v-if="getIsOpenNewSpaceModal" :key="openNewSpaceModalKey">
      <template #alertmodal-header>
        <div class="flex_end">
          <a tabindex="0" class="common-close-md cursor" @click="onCloseNewSpace">
            <img class="common-close-md" src="/media/images/icon/close-lg-icon.png" alt="close-lg-icon.png" />
          </a>
        </div>
      </template>

      <template #alertmodal-nontitle>
        스페이스를 만들고, <br />
        서비스를 계속 이용해보세요.
      </template>
      <template #confirmbtn>
        <BasicButton :boxsize="'md'" @click-btn="onConfirmBtnNewSpace">
          <template #btnname>스페이스 만들기</template>
        </BasicButton>
        <div class="newspace-btn">
          <BasicButton @click-btn="onCloseNewSpace" :boxsize="'md'" :bgcolor="'bg-black200'" :fontcolor="'ft-black'">
            <template #btnname>취소</template>
          </BasicButton>
        </div>
      </template>
    </AlertModalV2>

    <!-- 현재 스페이스 구독 모달 -->
    <AlertModalV2 v-if="getIsOpenUndescribeModal">
      <template #alertmodal-header>
        <div class="flex_end">
          <a tabindex="0" class="common-close-md cursor" @click="onClickIsOpenUndescribeModal">
            <img class="common-close-md" src="/media/images/icon/close-lg-icon.png" alt="close-lg-icon.png" />
          </a>
        </div>
      </template>
      <template #alertmodal-nontitle>
        어떤 스페이스를 구독할까요?
      </template>
      <template #confirmbtn>
        <BasicButton :boxsize="'md'" @click-btn="onConfirmBtnSubscribe1">
          <template #btnname>현재 스페이스</template>
        </BasicButton>
        <div class="newspace-btn">
          <BasicButton
            :boxsize="'md'"
            :bgcolor="'bg-black200'"
            :fontcolor="'ft-black'"
            @click-btn="onConfirmBtnSubscribe2"
          >
            <template #btnname>새로운 스페이스</template>
          </BasicButton>
        </div>
      </template>
      <template #btnname> </template>
    </AlertModalV2>
    <!-- 신고접수 완료 팝업 -->
    <AlertModalV2 v-if="isSuccessReport" @confirm-btn="isSuccessReport = false">
      <template #alertmodal-nontitle>
        신고가 정상 접수되었습니다. <br />
        빠른 시일 내에 수정하도록 하겠습니다.
      </template>
    </AlertModalV2>
    <!-- 스페이스 중복재생 팝업 -->
    <ConfirmYesNoV2
      v-if="isSpaceConnectionModal"
      @click-no="onClickNoSpaceConnection"
      @click-yes="onClickYesSpaceConnection"
    >
      <template #confirmmodal-nontitle>
        현재 스페이스는 다른 기기에서 이용 중입니다. 이 기기에서 스트리밍을 하시면 다른 기기에서 이용이 중단됩니다. 이
        기기에서 스트리밍 하시겠습니까?
      </template>
    </ConfirmYesNoV2>

    <!-- 장시간 플레이되지 않는 경우 -->
    <CommonIdlePlaylistLoader v-if="getIsIdlePlayListLoader" @close-loading="onCloseLoading" />
    <!-- 즐겨찾기 컴퍼넌트  -->
    <StarComp v-if="isOpenAnim" />
    <!-- 좋아요 컴퍼넌트 -->
    <LikeComp v-if="isOpenLikeAnim" />
    <!-- 싫어요 컴퍼넌트 -->
    <DisLikeComp v-if="isOpenDisLikeAnim" />
    <!-- 한줄평 컴퍼넌트-->
    <ReportModal v-if="isOpenReportModal" :musicInfo="musicInfo" @close-reportmodal="isOpenReportModal = false" />
    <!-- 신고하기 컴퍼넌트 -->
    <ReportV2
      v-if="isOpenReport"
      :musicid="currentMusicId"
      @close-modal="isOpenReport = false"
      @complete-save="onCompleteSave"
    />
    <!-- PageHeader -->
    <PageHeader v-if="isShowPageHeader" :isshowaiinputbox="isshowaiinputbox" @click-aside="onClickAside">
      <template #left-area>
        <slot name="left-area"></slot>
      </template>
      <template #center-area>
        {{ motitlename }}
      </template>
    </PageHeader>
    <!-- Aside -->
    <AsideV2 v-if="getIsOpenMenu" @logout-confirm="onLogoutConfirm" @click-aside="onClickAside" />
    <!-- Contents -->
    <main class="pageslot-contents" :class="classObject">
      <!-- 컨텐츠 -->
      <slot name="pageslot-contents"></slot>
    </main>

    <!-- MainFooter -->
    <PageFooter
      v-if="isshowpagefooter"
      :isplayaimusicsong="getIsPlayAiMusicSong"
      @click-miniplayer="onClickMiniPlayer"
      @click-report="onClickReport"
      @click-reportmodal="onClickReportModal"
      @click-newspace="onClickNewSpace"
      @click-unsubscribespace="onClickUnsubscribespace"
    />
    <!-- ExtendPlayer -->
    <ExtendPlayer
      v-if="isOpenMiniPlayer"
      @close-miniplayer="isOpenMiniPlayer = false"
      @click-bookmark="onClickBookmark"
    />
  </div>
</template>
<script>
import PageHeader from '../components/PageSlot/PageHeader.vue';
import PageFooter from '../components/PageSlot/PageFooter.vue';
import ExtendPlayer from '../components/player/ExtendPlayer.vue';
import AlertModalV2 from '../components/modal/AlertModalV2.vue';
import AsideV2 from '../layout/aside/AsideV2.vue';
import StarComp from '../components/player/StarComp.vue';
import LikeComp from '../components/player/LikeComp.vue';
import DisLikeComp from '../components/player/DisLikeComp.vue';
import ReportModal from '../components/MyMusic/ReportModal.vue';
import ReportV2 from '../components/modal/Player/ReportV2.vue';
import ConfirmYesNoV2 from '../components/common/ConfirmYesNoV2.vue';
import BasicButton from '../components/BasicButton/BasicButton.vue';
import CommonIdlePlaylistLoader from '../components/common/CommonIdlePlaylistLoader.vue';
import { spaceDisConnectApi } from '../service/api/spaceSessionApi';
import { logout } from '../service/api/authApi';
import { controller } from '@/service/axiosCancel';
export default {
  props: {
    isshowaiinputbox: {
      type: Boolean,
      required: false,
      default: true
    },
    isshowpagefooter: {
      type: Boolean,
      required: false,
      default: true
    },
    motitlename: {
      type: String,
      default: null,
      required: false
    },
    isflex: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    PageHeader,
    PageFooter,
    ExtendPlayer,
    AsideV2,
    StarComp,
    LikeComp,
    DisLikeComp,
    ReportModal,
    ReportV2,
    AlertModalV2,
    ConfirmYesNoV2,
    BasicButton,
    CommonIdlePlaylistLoader
  },
  data() {
    return {
      isOpenMiniPlayer: false,
      isOpenStar: false,
      isOpenReportModal: false,
      isOpenReport: false,
      isSuccessReport: false,
      isOpenNewSpaceModal: false,
      openNewSpaceModalKey: 0,
      isOpenUndescribeModal: false,
      musicInfo: {},
      isLogoutConfirm: false,
      userId: this.$cookies.get('userId'),
      spaceId: this.$cookies.get('spaceId'),
      accessToken: this.$cookies.get('aToken'),
      refreshToken: this.$cookies.get('rToken'),
      comeFrom: this.$cookies.get('comeFrom')
    };
  },
  created() {
    /* 1200이하 인 경우는 화면 이동시 마다 메뉴 닫기 */
    if (window.innerWidth <= 1200) {
      this.$store.commit('setIsOpenMenu', false);
    }

    /* 권한 감지 */
    this.$watch(
      () => this.$store.state.auth.AUTH_NAME,
      val => {
        if (val) {
          if (val === 'UNSUBSCRIBED_WITH_SPACE') {
            // setUnSubscribeFunc
            this.$store.commit('player/setUnSubscribeFunc', this.unSubscribedWithSpaceFunc);
          } else if (val === 'UNSUBSCRIBED_NO_SPACE') {
            this.$store.commit('player/setUnSubscribeFunc', this.unSubscribedNoSpaceFuncFunc);
          }
        }
      }
    );
  },
  mounted() {
    this.posSystemPointerEvent();
  },
  methods: {
    onCompleteSave() {
      this.$gatag.event('web_music_report_submit_alert_modal'); // 신고 완료 팝업
      this.isOpenReport = false;
      this.isSuccessReport = true;
    },
    /**
     * @description : Pos System Pointer Event
     */
    async posSystemPointerEvent() {
      /* 설치형 프로그램 PointerEvent */
      await this.$nextTick();
      if (navigator.userAgent.includes('APLAYZ PoS')) {
        const box = document.querySelector('.pageslot-contents');

        let startY = 0;
        let isDragging = false;

        box.addEventListener('pointerdown', e => {
          const tagName = e.target.tagName.toLowerCase();
          if (tagName !== 'input' && tagName !== 'textarea' && tagName !== 'select') {
            e.preventDefault();

            isDragging = true;
            startY = e.clientY;
          }
        });

        box.addEventListener('pointermove', e => {
          const tagName = e.target.tagName.toLowerCase();
          if (tagName !== 'input' && tagName !== 'textarea' && tagName !== 'select') {
            e.preventDefault();
            if (!isDragging) return;
            const deltaY = startY - e.clientY;
            box.scrollTop += deltaY;
            startY = e.clientY;
          }
        });
        const stopDragging = e => {
          e.preventDefault();
          isDragging = false;
        };

        box.addEventListener('pointerup', stopDragging);
        box.addEventListener('pointerleave', stopDragging);
      }
    },
    async onClickIsOpenUndescribeModal() {
      await this.$nextTick();
      this.$store.commit('player/setIsOpenUndescribeModal', false);
    },
    onClickNewSpace() {
      this.$router.push({ name: 'Product' });
    },
    unSubscribedWithSpaceFunc() {
      this.$gatag.event('web_main_page_subscribe_popup'); // 구독 팝업
      this.$store.commit('player/setIsOpenUndescribeModal', true);
    },
    async unSubscribedNoSpaceFuncFunc() {
      await this.$nextTick();
      this.$gatag.event('web_make_space_popup'); // 스페이스 만들기 팝업
      this.$store.commit('player/setIsOpenNewSpaceModal', true);
    },
    async logOut() {
      const comeFrom = this.comeFrom;
      try {
        await logout(this.accessToken, this.refreshToken, this.comeFrom);
      } catch (error) {
        console.log(error);
      } finally {
        this.$cookies.keys().forEach(cookie => {
          if (cookie.indexOf('common_notice') < 0) {
            this.$cookies.remove(cookie);
          }
        });
        this.$cookies.set('comeFrom', comeFrom);
        this.$store.commit('initData'); // vuex 데이터 초기화
        clearInterval(this.$store.state.musicInfoInterval);
        controller.abort();
        window.location.href = `${window.location.origin}/home`;
      }
    },
    async spaceDisConnect() {
      if (this.spaceId) {
        try {
          await spaceDisConnectApi(this.userId, this.spaceId, null);
        } catch (error) {
          console.log(error);
        } finally {
          this.logOut();
        }
      } else {
        this.logOut();
      }
    },

    onClickYesLogout() {
      this.$gatag.event('web_setting_page_logout'); // 로그아웃
      this.isLogoutConfirm = false;
      this.spaceDisConnect();
    },
    onLogoutConfirm() {
      this.isLogoutConfirm = true;
    },
    onClickUnsubscribespace() {
      this.$gatag.event('web_main_page_subscribe_popup'); // 구독 팝업
      this.$store.commit('player/setIsOpenUndescribeModal', true);
    },
    onConfirmBtnSubscribe1() {
      this.$gatag.event('web_subscribe_popup_current_space'); // 현재 스페이스 선택
      this.$store.commit('player/setIsOpenUndescribeModal', false);
      const spaceId = this.$cookies.get('spaceId');
      this.$router.push({ path: `/space/spacePayment/${spaceId}` });
    },
    onConfirmBtnSubscribe2() {
      this.$gatag.event('web_subscribe_popup_new_space'); // 새 스페이스 선택
      this.$router.push({ name: 'Product' });
    },
    onConfirmBtnNewSpace() {
      this.$gatag.event('web_subscribe_popup_new_space'); // 새 스페이스 선택
      this.$store.commit('player/setIsOpenNewSpaceModal', false);
      this.$router.push({ name: 'Product' });
    },
    onCloseNewSpace() {
      this.$store.commit('player/setIsOpenNewSpaceModal', false);
    },
    onClickReportModal() {
      if (!this.$store.state.channelMusicInfo.musicId) return;
      const musicInfo = {
        albumImg: `${this.$store.state.channelMusicInfo.albumImg}`,
        artist: this.$store.state.channelMusicInfo.artist,
        content: null,
        musicId: this.$store.state.channelMusicInfo.musicId,
        musicNm: this.$store.state.channelMusicInfo.musicNm,
        spaceId: this.$cookies.get('spaceId')
      };

      this.musicInfo = musicInfo;
      this.isOpenReportModal = true;
    },
    onClickReport() {
      this.isOpenReport = true;
    },
    onClickBookmark(item) {
      this.$store.dispatch('player/manageBookmarkv2', item);
    },
    onClickMiniPlayer() {
      this.isOpenMiniPlayer = !this.isOpenMiniPlayer;
    },
    onClickNoSpaceConnection() {
      this.$store.commit('player/setIsSpaceConnectionModal', false);
      this.$router.push({ path: '/myspace' });
    },
    async onClickYesSpaceConnection() {
      this.$store.commit('player/setIsSpaceConnectionModal', false);
      try {
        const sessionId = localStorage.getItem('sessionId');
        const recentSpaceId = localStorage.getItem('recentSpaceId');
        const params = {
          userId: this.userId,
          spaceId: this.spaceId,
          sessionId,
          recentSpaceId: recentSpaceId || this.spaceId
        };
        const isSpaceConnection = await this.$store.dispatch('player/spaceConnection', params);
        if (isSpaceConnection) {
          this.$store.dispatch('player/createNewChannel');
          this.$router.push({ path: '/main' });
        } else {
          throw Error(isSpaceConnection);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onCloseLoading() {
      this.$store.commit('player/setIsIdlePlayListLoader', false);
    },
    onClickAside() {
      if (this.$store.getters.getIsOpenMenu) {
        this.$gatag.event('web_my_menu_back_button'); // 마이 메뉴 뒤로가기
      }
      this.$store.commit('setIsOpenMenu', !this.$store.getters.getIsOpenMenu);
    },
    onClickDim() {
      this.$store.commit('setIsOpenMenu', false);
    }
  },
  computed: {
    getIsOpenNewSpaceModal() {
      return this.$store.getters['player/getIsOpenNewSpaceModal'];
    },
    getIsOpenUndescribeModal() {
      return this.$store.getters['player/getIsOpenUndescribeModal'];
    },
    classObject() {
      return {
        isopen: this.$store.getters.getIsOpenMenu,
        nofooter: !this.isshowpagefooter,
        isflex: this.isflex
      };
    },
    isOpenAnim() {
      return this.$store.getters['player/getIsOpenAnim'];
    },
    isOpenLikeAnim() {
      return this.$store.getters['player/getLikeIsOpenAnim'];
    },
    isOpenDisLikeAnim() {
      return this.$store.getters['player/getDisLikeIsOpenAnim'];
    },
    currentMusicId() {
      if (this.$store.state.channelMusicInfo.musicId) {
        return this.$store.state.channelMusicInfo.musicId;
      }
      return null;
    },
    isSpaceConnectionModal() {
      return this.$store.getters['player/getIsSpaceConnectionModal'];
    },
    getIsIdlePlayListLoader() {
      return this.$store.getters['player/getIsIdlePlayListLoader'];
    },
    getIsOpenMenu() {
      return this.$store.getters.getIsOpenMenu;
    },
    getIsPlayAiMusicSong() {
      return this.$store.getters['player/getIsPlayAiMusicSong'];
    },
    isShowPageHeader() {
      // 웹뷰
      return localStorage.getItem('fromMobile') !== 'Y';
    }
  }
};
</script>
<style scoped src="@/assets/css/pageslot/pageslot.css"></style>
